// 📄 pages/SAP-BTP/components/SelectorDocumentos.tsx
// Selección de documentos técnicos (todavía no subidos). La validación de
// acá es solo para avisar antes; el backend valida el contenido real.
import React from 'react';
import { FileText, Trash2, UploadCloud } from 'lucide-react';
import { ACCEPT_DOCUMENTO, MAX_DOCUMENTOS, tamanoLegible, validarDocumentosLocal } from '../../../services/iflowService.ts';

interface SelectorDocumentosProps {
  archivos: File[];
  onChange: (archivos: File[]) => void;
  onError: (mensaje: string | null) => void;
  // Documentos que el iFlow ya tiene (cuentan para el máximo).
  existentes?: number;
}

export default function SelectorDocumentos({ archivos, onChange, onError, existentes = 0 }: SelectorDocumentosProps) {
  const agregar = (files: FileList | null) => {
    if (!files) return;
    const nuevos = Array.from(files);
    const error = validarDocumentosLocal(existentes + archivos.length, nuevos);
    onError(error);
    if (!error) onChange([...archivos, ...nuevos]);
  };

  return (
    <div className="space-y-2">
      {archivos.map((f, i) => (
        <div key={`${f.name}-${i}`} className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm">
          <FileText className="w-4 h-4 text-cyan-400 flex-shrink-0" />
          <span className="text-white truncate flex-1">{f.name}</span>
          <span className="text-xs text-gray-500">{tamanoLegible(f.size)}</span>
          <button type="button" onClick={() => onChange(archivos.filter((_, j) => j !== i))} className="text-gray-400 hover:text-red-400" aria-label={`Quitar ${f.name}`}>
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ))}
      {existentes + archivos.length < MAX_DOCUMENTOS && (
        <label className="inline-flex items-center gap-2 text-xs text-cyan-300 hover:text-cyan-200 cursor-pointer">
          <UploadCloud className="w-4 h-4" /> Adjuntar documentos (PDF, Word, Excel, PowerPoint, Markdown, TXT, PNG, JPG · 20 MB c/u)
          <input type="file" multiple accept={ACCEPT_DOCUMENTO} className="hidden" onChange={(e) => { agregar(e.target.files); e.target.value = ''; }} />
        </label>
      )}
    </div>
  );
}
